<div class="dialog-overlay">
    <mat-card class="dialog-card" [ngClass]="currentTheme">
        <div class="dialog-header">
            <h2 class="dialog-title">{{ dialogTitle }}</h2>
            <button mat-icon-button class="close-button" (click)="onCancelClick()">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="dialog-content">
            <form [formGroup]="driverForm" class="driver-form">
                <div class="form-section">
                    <h3 class="section-title">Driver Information</h3>

                    <div class="input-wrapper">
                        <mat-icon class="input-icon">person</mat-icon>
                        <mat-form-field class="form-input" appearance="outline">
                            <mat-label>Driver Name</mat-label>
                            <input matInput
                                   formControlName="name"
                                   placeholder="Enter driver's full name"
                                   maxlength="100">
                            <mat-error *ngIf="driverForm.get('name')?.hasError('required')">
                                Driver name is required
                            </mat-error>
                            <mat-error *ngIf="driverForm.get('name')?.hasError('minlength')">
                                Driver name must be at least 2 characters long
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="phone-container">
                        <div class="input-wrapper country-code-wrapper">
                            <mat-icon class="input-icon">phone</mat-icon>
                            <mat-form-field class="form-input country-code-input" appearance="outline">
                                <mat-label>Country</mat-label>
                                <mat-select formControlName="countryCode">
                                    <mat-select-trigger>
                                        <span class="selected-country-display" *ngIf="selectedCountry">
                                            <span class="selected-flag">{{ selectedCountry.flag }}</span>
                                            <span class="selected-text">
                                                {{ selectedCountry.name }}
                                                <span class="selected-code">({{ selectedCountry.code }})</span>
                                            </span>
                                        </span>
                                    </mat-select-trigger>
                                    <mat-option *ngFor="let country of countryCodes" [value]="country.code">
                                        <div class="country-option">
                                            <div class="country-flag">{{ country.flag }}</div>
                                            <div class="country-info">
                                                <div class="country-name">{{ country.name }}</div>
                                                <div class="country-code-text">{{ country.code }}</div>
                                            </div>
                                        </div>
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="driverForm.get('countryCode')?.hasError('required')">
                                    Country is required
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="input-wrapper phone-number-wrapper">
                            <mat-form-field class="form-input phone-number-input" appearance="outline">
                                <mat-label>Phone Number</mat-label>
                                <input matInput
                                       formControlName="phoneNumber"
                                       placeholder="123456789"
                                       maxlength="15">
                                <mat-error *ngIf="driverForm.get('phoneNumber')?.hasError('required')">
                                    Phone number is required
                                </mat-error>
                                <mat-error *ngIf="driverForm.get('phoneNumber')?.hasError('pattern')">
                                    Please enter a valid phone number
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="validation-error" *ngIf="validationError">
                        <mat-icon color="warn">error</mat-icon>
                        <span>{{ validationError }}</span>
                    </div>
                </div>
            </form>
        </div>

        <div class="dialog-footer">
            <button mat-stroked-button
                    class="cancel-button"
                    (click)="onCancelClick()"
                    [disabled]="isLoading">
                <mat-icon>close</mat-icon>
                Cancel
            </button>
            <button mat-raised-button
                    class="add-driver-button"
                    (click)="onAddClick()"
                    [disabled]="driverForm.invalid || isLoading">
                <mat-icon *ngIf="isLoading" class="loading-icon">hourglass_empty</mat-icon>
                <mat-icon *ngIf="!isLoading">{{ buttonIcon }}</mat-icon>
                {{ isLoading ? (isEditMode ? 'Updating Driver...' : 'Adding Driver...') : buttonText }}
            </button>
        </div>
    </mat-card>
</div>
